// Favorite script
const customerId = window.theme.settings.favSet.cid;
const pageType = window.theme.settings.favSet.pageType;
const isProductPage = pageType === 'product';
let favoritedVariantIDinDb = null;

const pdpOriginalPriceSelector = '[data-product-price]';
const pdpCurrentVariantSelector = '[data-current-variant]';
const jumboCorparateNumber = 5;
const customerEmail = window.theme.settings.favSet.ce;

const BASE_URL = 'https://shopify-api.jumbo.com.tr';

const BTPRO_FAVORITE_API = {
    GET_TOKEN: BASE_URL + '/api/v1/customer/get-token',
    GET_FAVS: BASE_URL + '/api/v1/customer-favorites',
    ADD_FAV: BASE_URL + '/api/v1/customer-favorites',
    REMOVE_FAV: BASE_URL + '/api/v1/customer-favorites/remove',
};

let authTokenFav = null;

async function getAuthToken() {
    if (authTokenFav) {
        return authTokenFav;
    }
    if (!customerId || !customerEmail) {
        console.error("Token almak için customerId veya customerEmail bilgisi eksik.");
        return null;
    }
    const reqDatas = {
        email: customerEmail,
        customerId: customerId
    };
    try {
        const tokenRes = await fetch(BTPRO_FAVORITE_API.GET_TOKEN, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(reqDatas)
        });
        const tokenResponseJson = await tokenRes.json();
        if (tokenResponseJson.succeeded && tokenResponseJson.data && tokenResponseJson.data.token) {
            authTokenFav = tokenResponseJson.data.token;
            return authTokenFav;
        } else {
            console.error("Token alma başarısız:", tokenResponseJson.messages || "Bilinmeyen hata");
            return null;
        }
    } catch (e) {
        console.error("Token alırken hata oluştu:", e);
        return null;
    }
}

function isLoggedIn() {
    return !!customerId;
}

function addDecimal(str) {
    if (!str) return "";
    if (str.length < 3) {
        return str;
    }
    return str.slice(0, -2) + '.' + str.slice(-2);
}

function getTheGTMPageType() {
    let GTMPageType;
    switch (pageType) {
        case 'collection':
            GTMPageType = "Listeleme";
            break;
        case 'index':
            GTMPageType = "Anasayfa";
            break;
        case 'search':
            GTMPageType = "Search";
            break;
        case 'product':
            GTMPageType = "Listeleme";
            break;
        default:
            GTMPageType = "Anasayfa";
            break;
    }
    return GTMPageType;
}

function pushToDataLayer(svgIcon, eventType) {
    const d = svgIcon.dataset;
    const price = (Number(d.favprice) || 0) / 100;
    const firstPrice = Math.max(Number(d.favcompareprice) || 0, Number(d.favprice) || 0) / 100;
    const dataLayerObject = {
        event: eventType,
        ecommerce: {
            currency: "TRY",
            value: price,
            items: [{
                item_name: svgIcon.dataset.favtitle,
                item_id: d.favsku || d.variantfavid,
                price,
                discount: firstPrice - price,
                item_brand: svgIcon.dataset.favbrand || 'Jumbo',
                item_category: svgIcon.dataset.favcategory1,
                item_category2: svgIcon.dataset.favcategory2,
                item_category3: svgIcon.dataset.favcategory3,
                item_category4: svgIcon.dataset.favcategory4,
                item_category5: "",
                quantity: 1,
                item_list_id: getTheGTMPageType(),
                item_list_name: svgIcon.dataset.favlistname,
                item_variant: svgIcon.dataset.favvariant,
                item_first_price: firstPrice,
                item_sale_rate: '%' + (firstPrice ? Math.floor((firstPrice - price) / firstPrice * 100) : 0),
                item_stock: svgIcon.dataset.favitemstock,
                item_image: svgIcon.dataset.favimage,
                item_previous_id: svgIcon.dataset.favoldproductcode
            }]
        }
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(dataLayerObject);
}

// Helper function to extract product ID from GID
function extractProductIdFromGid(gid) {
    if (typeof gid === 'string' && gid.includes('gid://shopify/Product/')) {
        return gid.split('/').pop();
    }
    return gid;
}

// Helper function to extract variant ID from GID
function extractVariantIdFromGid(gid) {
    if (typeof gid === 'string' && gid.includes('gid://shopify/ProductVariant/')) {
        return gid.split('/').pop();
    }
    return gid;
}

async function setUserFavorite(data, svgIcon, isRemove = false) {
    const realSvg = svgIcon.matches('[data-favorite-item]') ? svgIcon : svgIcon.querySelector('[data-favorite-item]');
    // Snapshot the selected variant before awaiting the API.
    const analyticsIcon = { dataset: { ...realSvg?.dataset } };
    svgIcon.parentNode.classList.add('svg-loading');
    const token = await getAuthToken();
    if (!token) {
        console.error("Yetkilendirme token'ı bulunamadı, işlem iptal edildi.");
        svgIcon.parentNode.classList.remove('svg-loading');
        return false;
    }
    
    let url = isRemove ? BTPRO_FAVORITE_API.REMOVE_FAV : BTPRO_FAVORITE_API.ADD_FAV;
    let bodyData = {};
    
    if (isRemove) {
        bodyData = {
            favoriteProducts: [{
                ShopifyProductId: 'gid://shopify/Product/' + data.favoriteProduct.ProductTargetUniqueId,
                ShopifyProductVariantId: 'gid://shopify/ProductVariant/' + data.favoriteProduct.ProductVariantTargetUniqueId
            }]
        };
    } else {
        bodyData = {
            favoriteProducts: [{
                shopifyProductId: 'gid://shopify/Product/' + data.favoriteProduct.ProductTargetUniqueId,
                shopifyProductVariantId: 'gid://shopify/ProductVariant/' + data.favoriteProduct.ProductVariantTargetUniqueId,
                priceWhenFavorited: data.favoriteProduct.oldPrice / 100,
            }]
        };
    }
    
    let success = false;
    try {
        const res = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify(bodyData)
        });
        const fetchResponse = await res.json();
        success = res.ok && fetchResponse.succeeded === true;
        
        if (!fetchResponse.succeeded) {
            console.error("API işlemi başarısız oldu: ", fetchResponse.messages);
        }
    } catch (e) {
        console.warn("setUserFavorite ", e);
    } finally {
        svgIcon.parentNode.classList.remove('svg-loading');
        if (success) {
            if (realSvg) pushToDataLayer(analyticsIcon, isRemove ? 'remove_from_wishlist' : 'add_to_wishlist');
        } else {
            window.JumboAnalytics?.error('Favorite Error', isRemove ? 'Remove failed' : 'Add failed');
        }
    }
    return success;
}

function handleLocalStorage(key, data) {
    if (customerId) return;
    const favorites = localStorage.getItem(key);
    let favoritesArray = favorites ? JSON.parse(favorites) : [];
    const dataKey = data.favoriteProduct.ProductTargetUniqueId;
    let hasData = false;
    for (let i = 0; i < favoritesArray.length; i++) {
        if (favoritesArray[i].favoriteProduct.ProductTargetUniqueId == dataKey) {
            favoritesArray.splice(i, 1);
            hasData = true;
            break;
        }
    }
    if (!hasData) {
        favoritesArray.push(data);
    }
    localStorage.setItem(key, JSON.stringify(favoritesArray));
}

function handleSessionStorage(key, data, isRemove = false) {
    if (!customerId) return;
    const favorites = sessionStorage.getItem(key);
    let favoritesArray = favorites ? JSON.parse(favorites) : [];
    const dataKey = data.favoriteProduct.ProductTargetUniqueId;

    if (isRemove) {
        favoritesArray = favoritesArray.filter(item => {
            const itemId = extractProductIdFromGid(item.shopifyProductId);
            return itemId != dataKey;
        });
    } else {
        let hasData = false;
        for (let i = 0; i < favoritesArray.length; i++) {
            const itemId = extractProductIdFromGid(favoritesArray[i].shopifyProductId);
            if (itemId == dataKey) {
                favoritesArray.splice(i, 1);
                hasData = true;
                break;
            }
        }
        if (!hasData) {
            favoritesArray.push({
                shopifyProductId: 'gid://shopify/Product/' + data.favoriteProduct.ProductTargetUniqueId,
                shopifyProductVariantId: 'gid://shopify/ProductVariant/' + data.favoriteProduct.ProductVariantTargetUniqueId,
                title: data.favoriteProduct.Data ? JSON.parse(data.favoriteProduct.Data).title : '',
                handle: data.favoriteProduct.Data ? JSON.parse(data.favoriteProduct.Data).handle : '',
                images: data.favoriteProduct.Data ? [JSON.parse(data.favoriteProduct.Data).img] : [],
                price: data.favoriteProduct.oldPrice / 100,
                priceWhenFavorited: data.favoriteProduct.oldPrice / 100,
            });
        }
    }
    sessionStorage.setItem(key, JSON.stringify(favoritesArray));
}

async function handleClickFavorite(e, svgEl) {
    if (window.Flutter) {
        window.Flutter.postMessage(svgEl.dataset.productfavid);
        return;
    }
    const isLogin = isLoggedIn();
    if (!isLogin) {
        window.location.assign('/account/login?return_url=%2Fpages%2Ffavoriler');
        return;
    }
    if (pageType === 'cart') {
        svgEl = e.detail?.customCurrentTarget || svgEl;
        if (svgEl.matches?.('[data-favorite-item]') !== true) svgEl = svgEl.querySelector('[data-favorite-item]');
        if (!svgEl || svgEl.classList.contains('fill-black')) return;
    }
    e.preventDefault();
    if (svgEl.dataset.favoritePending === 'true') return;
    const productData = {
        title: svgEl.dataset.favtitle,
        handle: svgEl.dataset.favhandle,
        img: svgEl.dataset.favimg,
        price: svgEl.dataset.favprice,
        cprice: svgEl.dataset.favcompareprice,
        vname: svgEl.dataset.favvariantname
    };
    const data = {
        favoriteProduct: {
            ProductTargetUniqueId: svgEl.dataset.productfavid,
            ProductVariantTargetUniqueId: svgEl.dataset.variantfavid,
            CustomerTargetUniqueId: customerId,
            corporateCountry: jumboCorparateNumber,
            oldPrice: svgEl.dataset.favprice,
            Data: JSON.stringify(productData)
        }
    };
    
    const isFavorited = svgEl.classList.contains('fill-black');

    if (!customerId) {
        handleLocalStorage('favoriteItems', data);
        return;
    }

    svgEl.dataset.favoritePending = 'true';
    try {
        if (await setUserFavorite(data, svgEl, isFavorited)) {
            svgEl.classList.toggle('fill-black', !isFavorited);
            handleSessionStorage('favoriteItems', data, isFavorited);
        }
    } finally {
        delete svgEl.dataset.favoritePending;
    }
}

function handleFlutterWebviewClick({ customerData, productId }) {
    try {
        const favoritedElement = document.querySelector(`[data-productfavid="${+productId}"]`);
        if (favoritedElement) {
            const productData = {
                title: favoritedElement.dataset.favtitle,
                handle: favoritedElement.dataset.favhandle,
                img: favoritedElement.dataset.favimg,
                price: favoritedElement.dataset.favprice,
                cprice: favoritedElement.dataset.favcompareprice,
                vname: favoritedElement.dataset.favvariantname
            };
            const data = {
                favoriteProduct: {
                    ProductTargetUniqueId: favoritedElement.dataset.productfavid,
                    ProductVariantTargetUniqueId: favoritedElement.dataset.variantfavid,
                    CustomerTargetUniqueId: Number(customerData),
                    corporateCountry: jumboCorparateNumber,
                    oldPrice: favoritedElement.dataset.favprice,
                    Data: JSON.stringify(productData)
                }
            };
            
            const isFavorited = favoritedElement.classList.contains('fill-black');
            favoritedElement.classList.toggle('fill-black');
            
            if (isFavorited) {
                setUserFavorite(data, favoritedElement.parentNode, true);
                handleSessionStorage('favoriteItems', data, true);
            } else {
                setUserFavorite(data, favoritedElement.parentNode, false);
                handleSessionStorage('favoriteItems', data, false);
            }
        }
    } catch (error) {
        console.warn(error);
        if (window.Flutter) {
            window.Flutter.postMessage(JSON.stringify(error));
            return;
        }
    }
}

function getVariantParams() {
    const params = new URLSearchParams(window.location.search);
    return +params.get('variant') || +document.querySelector('[data-current-variant]')?.getAttribute('data-current-variant');
}

function handleClickPDPFavorite(e, svgEl) {
    const isLogin = isLoggedIn();
    if (!isLogin) {
        window.location.assign('/account/login?return_url=%2Fpages%2Ffavoriler');
        return;
    }
    const isFavorited = favoritedVariantIDinDb !== null;
    const productData = {
        title: svgEl.dataset.favtitle,
        handle: svgEl.dataset.favhandle,
        img: svgEl.dataset.favimg,
        price: svgEl.dataset.favprice,
        cprice: svgEl.dataset.favcompareprice,
        vname: svgEl.dataset.favvariantname
    };
    const data = {
        favoriteProduct: {
            ProductTargetUniqueId: svgEl.dataset.productfavid,
            ProductVariantTargetUniqueId: svgEl.dataset.variantfavid,
            CustomerTargetUniqueId: customerId,
            oldPrice: svgEl.dataset.favprice,
            corporateCountry: jumboCorparateNumber
        }
    };
    
    svgEl.classList.toggle('fill-black');
    
    if (isFavorited) {
        handleDeleteFavorite(data, svgEl);
    } else {
        handleAddFavorite(data, productData, svgEl);
    }
}

function handleAddFavorite(data, productData, svgIcon) {
    const currentVariant = getVariantParams();
    const currentPrice = Number(document.querySelector(pdpOriginalPriceSelector).innerText.replace(/\D/g, ""));
    let variantStr = "";
    const currentVariantNames = document.querySelectorAll(pdpCurrentVariantSelector);
    currentVariantNames.forEach((item, i) => {
        variantStr += item.innerText;
        i === 0 ? variantStr += ' / ' : null;
    });

    productData.price = currentPrice;
    productData.vname = variantStr;
    data.favoriteProduct.ProductVariantTargetUniqueId = currentVariant;
    data.favoriteProduct.oldPrice = currentPrice;
    data.favoriteProduct.Data = JSON.stringify(productData);

    favoritedVariantIDinDb = currentVariant;
    
    if (!customerId) {
        const favorites = localStorage.getItem('favoriteItems');
        const arr = favorites ? JSON.parse(favorites) : [];
        arr.push(data);
        localStorage.setItem('favoriteItems', JSON.stringify(arr));
        return;
    }
    
    handleSessionStorage('favoriteItems', data, false);
    setUserFavorite(data, svgIcon, false);
}

function handleDeleteFavorite(data, svgIcon) {
    data.favoriteProduct.ProductVariantTargetUniqueId = favoritedVariantIDinDb;
    favoritedVariantIDinDb = null;
    
    if (!customerId) {
        const favorites = localStorage.getItem('favoriteItems');
        let arr = favorites ? JSON.parse(favorites) : [];
        arr = arr.filter(item => item.favoriteProduct.ProductTargetUniqueId != data.favoriteProduct.ProductTargetUniqueId);
        localStorage.setItem('favoriteItems', JSON.stringify(arr));
        return;
    }
    
    handleSessionStorage('favoriteItems', data, true);
    setUserFavorite(data, svgIcon, true);
}

async function setLocalStorageToDb(response, localfavs) {
    const token = await getAuthToken();
    if (!token) {
        console.error("Yetkilendirme token'ı bulunamadı, localStorage senkronizasyonu iptal edildi.");
        return;
    }
    const parsed = JSON.parse(localfavs);
    const dbIdArray = response.map(item => extractProductIdFromGid(item.shopifyProductId));
    for (let i = 0; i < parsed.length; i++) {
        if (!dbIdArray.includes(parsed[i].favoriteProduct.ProductTargetUniqueId)) {
            const dataToSend = {
                favoriteProducts: [{
                    shopifyProductId: 'gid://shopify/Product/' + parsed[i].favoriteProduct.ProductTargetUniqueId,
                    shopifyProductVariantId: 'gid://shopify/ProductVariant/' + parsed[i].favoriteProduct.ProductVariantTargetUniqueId,
                    priceWhenFavorited: parsed[i].favoriteProduct.oldPrice / 100,
                }]
            };
            await fetch(BTPRO_FAVORITE_API.ADD_FAV, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify(dataToSend)
            });
        }
    }
    localStorage.removeItem('favoriteItems');
    getUserFavorites();
}

function handleFillFavoriteIcons(data, allFavoriteIcons, isSession = false) {
    if (!data || !data.length) {
        allFavoriteIcons.forEach(icon => icon.parentNode.classList.remove('svg-loading'));
        return;
    }

    let userFavoriteMap;
    if (!customerId) {
        data = data.map(item => item.favoriteProduct);
        userFavoriteMap = new Map(data.map(item => [item.ProductTargetUniqueId, item.ProductVariantTargetUniqueId]));
    } else {
        // API'dan gelen veriler için - her zaman GID formatında
        userFavoriteMap = new Map(data.map(item => [
            extractProductIdFromGid(item.shopifyProductId),
            extractVariantIdFromGid(item.shopifyProductVariantId)
        ]));
    }

    requestAnimationFrame(() => {
        allFavoriteIcons.forEach(icon => {
            const id = icon.dataset.productfavid;
            const variantId = icon.dataset.variantfavid;

            let isFavorited = false;
            for (const [favProdId, favVarId] of userFavoriteMap.entries()) {
                if (String(favProdId) === String(id) && String(favVarId) === String(variantId)) {
                    isFavorited = true;
                    break;
                }
            }

            if (isFavorited) {
                icon.classList.add('fill-black');
            } else {
                icon.classList.remove('fill-black');
            }
            icon.parentNode.classList.remove('svg-loading');
        });

        if (isProductPage) {
            const currentVariantFromUrl = getVariantParams();
            const currentProductId = document.querySelector('[data-productfavid]')?.dataset.productfavid;

            const sessionFavorites = sessionStorage.getItem('favoriteItems');
            if (sessionFavorites) {
                const parsedSessionFavorites = JSON.parse(sessionFavorites);
                for (const item of parsedSessionFavorites) {
                    const favProdId = extractProductIdFromGid(item.shopifyProductId);
                    const favVarId = extractVariantIdFromGid(item.shopifyProductVariantId);

                    if (String(favProdId) === String(currentProductId) && String(currentVariantFromUrl) === String(favVarId)) {
                        favoritedVariantIDinDb = favVarId;
                        const pdpFavIcon = document.querySelector('[data-favorite-item][data-productselector]');
                        if (pdpFavIcon) {
                            pdpFavIcon.classList.add('fill-black');
                        }
                        break;
                    }
                }
            }
        }
    });
}

async function getUserFavorites() {
    const allFavoriteIcons = document.querySelectorAll('[data-favorite-item]');
    if (!allFavoriteIcons || allFavoriteIcons.length === 0) return;

    allFavoriteIcons.forEach(icon => icon.parentNode.classList.add('svg-loading'));

    const localFavorites = localStorage.getItem('favoriteItems');
    if (!customerId && localFavorites) {
        handleFillFavoriteIcons(JSON.parse(localFavorites), allFavoriteIcons);
        return;
    }
    if (!customerId && !localFavorites) {
        allFavoriteIcons.forEach(icon => icon.parentNode.classList.remove('svg-loading'));
        return;
    }

    const sessionFavorites = sessionStorage.getItem('favoriteItems');
    if (sessionFavorites && sessionFavorites !== 'undefined') {
        const parsedSessionFavorites = JSON.parse(sessionFavorites);
        if (parsedSessionFavorites.length) {
            handleFillFavoriteIcons(parsedSessionFavorites, allFavoriteIcons, true);
            return;
        }
    }

    const token = await getAuthToken();
    if (!token) {
        console.error("Yetkilendirme token'ı bulunamadı, favoriler getirilemedi.");
        allFavoriteIcons.forEach(icon => icon.parentNode.classList.remove('svg-loading'));
        return;
    }

    try {
        const res = await fetch(BTPRO_FAVORITE_API.GET_FAVS, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });

        const fetchResponse = await res.json();
        if (!fetchResponse.succeeded) {
            console.error("Favoriler getirilirken API hatası:", fetchResponse.messages);
            allFavoriteIcons.forEach(icon => icon.parentNode.classList.remove('svg-loading'));
            return;
        }
        const responseData = fetchResponse.data;

        if (customerId && localFavorites && responseData) {
            setLocalStorageToDb(responseData, localFavorites);
            return;
        }

        sessionStorage.setItem('favoriteItems', JSON.stringify(responseData));
        handleFillFavoriteIcons(responseData, allFavoriteIcons);
    } catch (e) {
        console.error("getUserFavorites", e);
        allFavoriteIcons.forEach(icon => icon.parentNode.classList.remove('svg-loading'));
    }
}

window.addEventListener("DOMContentLoaded", getUserFavorites);
